"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}
/* eslint-disable max-len */


var BogoInfoIcon = function BogoInfoIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "13",
    height: "14",
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.88265 10.1665H6.88262V6.33315H5.88265V10.1665ZM6.38263 5.19214C6.5352 5.19214 6.66308 5.14054 6.76628 5.03734C6.86948 4.93414 6.92108 4.80625 6.92108 4.65369C6.92108 4.50113 6.86948 4.37325 6.76628 4.27004C6.66308 4.16684 6.5352 4.11524 6.38263 4.11524C6.23007 4.11524 6.10218 4.16684 5.99898 4.27004C5.89578 4.37325 5.84418 4.50113 5.84418 4.65369C5.84418 4.80625 5.89578 4.93414 5.99898 5.03734C6.10218 5.14054 6.23007 5.19214 6.38263 5.19214ZM6.38375 13.3331C5.50779 13.3331 4.68444 13.1669 3.91368 12.8345C3.14292 12.502 2.47246 12.0509 1.90232 11.481C1.33216 10.9111 0.880789 10.2409 0.5482 9.47049C0.215611 8.70008 0.0493164 7.87689 0.0493164 7.00094C0.0493164 6.12498 0.215539 5.30163 0.547983 4.53087C0.880428 3.7601 1.33159 3.08965 1.90148 2.5195C2.47138 1.94935 3.14154 1.49798 3.91197 1.16539C4.68238 0.832799 5.50556 0.666504 6.38152 0.666504C7.25747 0.666504 8.08083 0.832727 8.85158 1.16517C9.62235 1.49762 10.2928 1.94878 10.863 2.51867C11.4331 3.08857 11.8845 3.75873 12.2171 4.52915C12.5497 5.29957 12.716 6.12275 12.716 6.9987C12.716 7.87466 12.5497 8.69802 12.2173 9.46877C11.8848 10.2395 11.4337 10.91 10.8638 11.4801C10.2939 12.0503 9.62372 12.5017 8.8533 12.8343C8.08289 13.1668 7.25971 13.3331 6.38375 13.3331ZM6.38263 12.3332C7.87152 12.3332 9.13263 11.8165 10.166 10.7832C11.1993 9.74982 11.716 8.48871 11.716 6.99982C11.716 5.51093 11.1993 4.24982 10.166 3.21649C9.13263 2.18315 7.87152 1.66649 6.38263 1.66649C4.89374 1.66649 3.63263 2.18315 2.5993 3.21649C1.56597 4.24982 1.0493 5.51093 1.0493 6.99982C1.0493 8.48871 1.56597 9.74982 2.5993 10.7832C3.63263 11.8165 4.89374 12.3332 6.38263 12.3332Z",
    fill: "white"
  }));
};

var _default = BogoInfoIcon;
exports.default = _default;